import classnames from 'classnames';
import React, { ReactNode } from 'react';

import { TheaterService } from 'types/graphql-api.generated';

import {
  BRAND_HAS_ACCES_LIBRE,
  IMAGE_EMPTY_PHOTO_LANDSCAPE,
  IMG_CINE_RELAX
} from 'common/configuration/constants';
import { path } from 'common/tools/network/routing';
import { getImageUrl } from 'common/tools/network/url';
import trans from 'common/tools/translations/trans';
import { ReduxUser } from 'common/types';

import AccesLibreLink from 'website/components/AccesLibreLink';
import Thumbnail from 'website/components/ui/Thumbnail';
import FavoriteTheaterButton from 'website/components/user/FavoriteTheaterButton';
import { PartialTheater } from 'website/containers/showtimes/utils/types';
import { Dispatch } from 'website/reducers';

type TheaterCardProps = {
  theater?: PartialTheater;
  dispatch: Dispatch;
  children?: ReactNode;
  user?: ReduxUser | null;
};

const TheaterCard = ({
  theater,
  children,
  user,
  dispatch
}: TheaterCardProps) => {
  const theaterTitle = theater?.name ?? '';
  const theaterPath = path('theater_showtimes', {
    idTheater: theater?.internalId ?? undefined
  });

  const theaterImg = getImageUrl({
    src: theater?.poster?.path ?? IMAGE_EMPTY_PHOTO_LANDSCAPE,
    format: { rw: 70, rh: 70 }
  });
  const theaterAdress = `${theater?.location?.address} ${theater?.location?.zip} ${theater?.location?.city}`;

  const theaterThumbnail = (
    <Thumbnail
      href={theaterPath}
      size="square"
      src={theaterImg}
      title={theaterTitle}
    />
  );

  const theaterButton = user && (
    <FavoriteTheaterButton
      dispatch={dispatch}
      iconOnly
      theaterId={theater?.internalId}
      theaterName={theater?.name}
      trackingContext="standalone"
      user={user}
    />
  );

  const AccesLibreComponent = BRAND_HAS_ACCES_LIBRE && (
    <AccesLibreLink theater={theater} />
  );

  const theaterMeta = (
    <div className="meta-theater">
      <div className="meta-theater-title">
        <h2 className="title">
          <a href={theaterPath}>{theaterTitle}</a>
        </h2>
        {theaterButton}
      </div>
      {theater?.location?.address && theater.location.city && (
        <address
          className={classnames('address', {
            'address-with-acces': !!AccesLibreComponent
          })}
        >
          {theaterAdress}
        </address>
      )}
      {AccesLibreComponent}
    </div>
  );

  const theaterService = (
    <div className="theater-notice theater-notice-autism">
      <span className="cine-relax-logo">
        <img src={IMG_CINE_RELAX} width="38" height="20" />
      </span>
      <span className="theater-notice-text">
        {trans('theater.autism.short')}
      </span>
    </div>
  );

  return (
    <div className="theater-card hred cf">
      <div className="theater-infos">
        {theaterThumbnail}
        {theaterMeta}
      </div>
      {theater?.service?.includes(TheaterService.Autism) && theaterService}
      {children}
    </div>
  );
};

export default TheaterCard;
